var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHandicraft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  className: "handicraft_svg__svg-inline--fa handicraft_svg__fa-chair handicraft_svg__fa-w-14",
  "data-icon": "chair",
  "data-prefix": "fal",
  viewBox: "0 0 448 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m446.21 341.52-22.19-64c-4.46-12.88-16.6-21.52-30.23-21.52H384V128C384 57.31 326.69 0 256 0h-64C121.31 0 64 57.31 64 128v128h-9.79c-13.63 0-25.77 8.64-30.23 21.52l-22.19 64C-5.42 362.31 10.02 384 32.03 384H32v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V384h320v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8l-.03-120c22.01 0 37.45-21.69 30.24-42.48M288 37.9c37.17 13.25 64 48.44 64 90.1v128h-64zM192 32h64v224h-64zm-96 96c0-41.66 26.83-76.85 64-90.1V256H96zM32.03 352l22.19-64h339.57l22.19 64z"
})));
export default SvgHandicraft;